import { NgModule } from '@angular/core'
import { SharedModule } from '../../../core/modules/shared.module'
import { DocumentListComponent } from './document-list/document-list.component'
import { DocumentDetailsComponent } from './document-details/document-details.component'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../../authentication/auth.guard'
import { DocumentsService } from '../../services/documents.service'
import { DocumentListSidenavComponent } from './document-list/document-list-sidenav/document-list-sidenav.component'
import { DocumentDetailsFormComponent } from './document-details/document-details-form/document-details-form.component'
import { DocumentDetailsViewComponent } from './document-details/document-details-view/document-details-view.component'
import { PdfViewerModule } from 'ng2-pdf-viewer'

const routes: Routes = [
  {
    path: 'documents',
    component: DocumentListComponent,
    canActivate: [AuthGuard],
    resolve: {
      documentResponse: DocumentsService,
    },
  },
  {
    path: 'documents/:documentId',
    component: DocumentDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      document: DocumentsService,
    },
  },
]

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes), PdfViewerModule],
  providers: [DocumentsService],
  declarations: [
    DocumentListComponent,
    DocumentListSidenavComponent,
    DocumentDetailsComponent,
    DocumentDetailsFormComponent,
    DocumentDetailsViewComponent,
  ],
})
export class DocumentsModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/documents.module.ts